/*
 * Copyright by Intland Software
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of Intland Software. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with Intland.
 */
import { IFrameWidget } from "./iframe-widget";
import { IFrameWidgetHandlers } from "./iframe-widget-handlers";
import { EventNames } from "@intland/cb-widget-shared";
var IFrameWidgets = /** @class */ (function () {
    function IFrameWidgets() {
        this.selectedItem = undefined;
        this.selectedStream = undefined;
        this.selectedStreamBaselineId = undefined;
        this.selectedStreamBaselineName = undefined;
        this.preferredLanguage = undefined;
        this.widgets = [];
    }
    IFrameWidgets.prototype.registerIframe = function (iframe, url, config) {
        var handlers = new IFrameWidgetHandlers(config || {}, iframe, this.selectedItem, this.selectedStream, this.selectedStreamBaselineId, this.selectedStreamBaselineName, this.preferredLanguage);
        this.widgets.push(new IFrameWidget(window, iframe, url, handlers));
    };
    IFrameWidgets.prototype.emitItemChange = function (itemId) {
        this.selectedItem = itemId;
        this.widgets = this.widgets.filter(function (widget) { return document.contains(widget.iFrame); });
        this.widgets.forEach(function (widget) {
            widget.setSelectedItem(itemId);
            widget.sendEvent(EventNames.SELECTED_ITEM_CHANGED, { itemId: itemId });
        });
    };
    IFrameWidgets.prototype.emitStreamChange = function (streamId) {
        this.selectedStream = streamId;
        this.widgets = this.widgets.filter(function (widget) { return document.contains(widget.iFrame); });
        this.widgets.forEach(function (widget) {
            widget.setSelectedStream(streamId);
            widget.sendEvent(EventNames.SELECTED_STREAM_CHANGED, { streamId: streamId });
        });
    };
    IFrameWidgets.prototype.emitStreamBaselineChange = function (streamBaseline) {
        if (streamBaseline != null && streamBaseline != "") {
            var streamBaselineContext_1 = JSON.parse(streamBaseline);
            this.selectedStreamBaselineId = streamBaselineContext_1.streamBaselineId;
            this.selectedStreamBaselineName = streamBaselineContext_1.streamBaselineName;
            this.widgets = this.widgets.filter(function (widget) { return document.contains(widget.iFrame); });
            this.widgets.forEach(function (widget) {
                widget.setSelectedStreamBaseline(streamBaselineContext_1.id, streamBaselineContext_1.name);
                widget.sendEvent(EventNames.SELECTED_STREAM_BASELINE_CHANGED, { streamBaselineId: streamBaselineContext_1.id,
                    streamBaselineName: streamBaselineContext_1.name });
            });
        }
    };
    IFrameWidgets.prototype.emitLanguageChange = function (languageTag) {
        this.preferredLanguage = languageTag;
        this.widgets = this.widgets.filter(function (widget) { return document.contains(widget.iFrame); });
        this.widgets.forEach(function (widget) {
            widget.setPreferredLanguage(languageTag);
            widget.sendEvent(EventNames.PREFERRED_LANGUAGE_CHANGED, { languageTag: languageTag });
        });
    };
    return IFrameWidgets;
}());
export { IFrameWidgets };
